import React, { useEffect, useState, useRef } from 'react';
import Spinner from '../common/Spinner';
import { scaleScreenTypes, getScalingScreenTypeDimensions } from '../../utils/helpers'
import './styles.css';

const ScalablePreview = ({ htmlToDisplay, toggleRefresh, scaleScreenType = scaleScreenTypes.DYNAMIC }) => {

    const [previewScalingRate, setPreviewScalingRate] = useState(0);
    const [changeHappened, setChangeHappened] = useState(false);

    const wrapper = useRef(null);

    const refreshPreview = () => {
        !changeHappened && setChangeHappened(true)
        setTimeout(() => { setChangeHappened(false) }, 1000)
    }

    const screenDimensions = getScalingScreenTypeDimensions(scaleScreenType);

    const updateScalingRate = () => {
        if (wrapper && wrapper.current) {
            let denominator = screenDimensions.scaleRatioDenominator;
            let scalingRate = wrapper.current.clientWidth / denominator;
            if (scalingRate > 1) {
                scalingRate = 1
            }
            if (scalingRate !== previewScalingRate) {
                setPreviewScalingRate(scalingRate);
            }
        }
    }

    // Add screen resize listener on element mount
    useEffect(() => {
        window.addEventListener('resize', refreshPreview);
        return () => {
            window.removeEventListener('resize', refreshPreview);
        };
    }, [])

    useEffect(() => {
        refreshPreview()
    }, [htmlToDisplay, toggleRefresh])

    useEffect(() => {
        !changeHappened && updateScalingRate()
    }, [changeHappened])

    return (
        <div className='td-scalable-preview'>
            {changeHappened &&
                <div className='td-scalable-preview-overlay'>
                    <Spinner />
                </div>
            }
            <div className="td-scalable-preview-container">
                <div
                    className={"td-scalable-preview-content-wrapper" + (previewScalingRate >= 1 ? " centered" : "")}
                    ref={wrapper}
                    style={{ height: `calc(${screenDimensions.height} * ${previewScalingRate})` }}
                >
                    <div
                        className="td-scalable-preview-content"
                        style={{ transform: `scale(${previewScalingRate})`, height: screenDimensions.height, width: screenDimensions.width }}
                        dangerouslySetInnerHTML={{ __html: htmlToDisplay ? htmlToDisplay : '' }}
                    />
                </div>
            </div>
        </div>
    )
}

export default ScalablePreview;
